module.exports = __webpack_public_path__ + "img/first-place.d47e791d.jpg";